import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MAT_RADIO_DEFAULT_OPTIONS, MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NSSkeletonModule } from '@norfolk-southern/accessns-components';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

import { SelectCompanyProviderComponent } from '@ruby/modules/third-party/submodules/third-contract/components/select-company-provider/select-company-provider.component';
import { SelectCompanyComponent } from '@ruby/modules/third-party/submodules/third-contract/components/select-company/select-company.component';
import { ThirdPartyAuthorizationsComponent } from '@ruby/modules/third-party/submodules/third-contract/components/third-authorization/third-authorization.component';
import { ThirdContractComponent } from '@ruby/modules/third-party/submodules/third-contract/components/third-contract.component';
import { ThirdPartyDoneComponent } from '@ruby/modules/third-party/submodules/third-contract/components/third-party-done/third-party-done.component';
import { SelectCompanyProviderContainerComponent } from '@ruby/modules/third-party/submodules/third-contract/containers/select-company-provider/select-company-provider.container';
import { SelectCompanyContainerComponent } from '@ruby/modules/third-party/submodules/third-contract/containers/select-company/select-company.container';
import { ThirdPartyAuthorizationContainerComponent } from '@ruby/modules/third-party/submodules/third-contract/containers/third-authorization/third-authorization.container';
import { ThirdPartyContractContainerComponent } from '@ruby/modules/third-party/submodules/third-contract/containers/third-contract.container';
import { ThirdPartyDoneContainerComponent } from '@ruby/modules/third-party/submodules/third-contract/containers/third-party-done/third-party-done.container';
import { ThirdPartyPreviewContainerComponent } from '@ruby/modules/third-party/submodules/third-contract/containers/third-preview/third-preview.container';
import { ThirdPartyContractRoutingModule } from '@ruby/modules/third-party/submodules/third-contract/third-party-contract-routing.module';
import { PureThirdPartyContractModule } from '@ruby/shared/components/third-party-contract/pure-third-party-contract.module';
import { ThirdPartyDialogModule } from '@ruby/shared/dialogs/third-party/third-party.dialog.module';
import { DirectivesModule } from '@ruby/shared/directives/directives.module';

@NgModule({
  declarations: [
    ThirdPartyContractContainerComponent,
    ThirdContractComponent,
    SelectCompanyComponent,
    SelectCompanyProviderComponent,
    ThirdPartyAuthorizationsComponent,
    SelectCompanyContainerComponent,
    SelectCompanyProviderContainerComponent,
    ThirdPartyAuthorizationContainerComponent,
    ThirdPartyPreviewContainerComponent,
    ThirdPartyDoneComponent,
    ThirdPartyDoneContainerComponent
  ],
  imports: [
    CommonModule,
    DirectivesModule,
    MatDividerModule,
    MatTooltipModule,
    MatListModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    MatStepperModule,
    ReactiveFormsModule,
    MatInputModule,
    NSSkeletonModule,
    SweetAlert2Module,
    ThirdPartyContractRoutingModule,
    PureThirdPartyContractModule,
    ThirdPartyDialogModule
  ],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false }
    },
    {
      provide: MAT_RADIO_DEFAULT_OPTIONS,
      useValue: { color: 'accent' }
    }
  ],
  exports: [ThirdPartyContractContainerComponent]
})
export class ThirdPartyContractModule {}
